<template>
    <div
        ref="video"
        class="w-full h-full relative"
    >
        <client-only>
            <vimeo-player
                v-if="shouldShowVideo"
                ref="vimeoPlayer"
                class="object-cover w-full h-full"
                :video-id="vimeoId"
                :autoplay="true"
                :player-width="width"
                :player-height="height"
                :loop="true"
                :options="{
                    muted: false,
                    unmute_button: true,
                    progress_bar: true,
                    play_button_position: 'center',
                    controls: true
                }"
                @ready="onVideoReady"
                @play="onVideoPlay"
                @pause="onVideoPause"
            />
            <div
                v-else
                class="w-full h-full flex items-center justify-center bg-gray-100"
            />

        </client-only>
    </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
    name: 'ProductVideo',
    components: {
        vueVimeoPlayer,
    },
    props: {
        vimeoId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        thumbnailUrl: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            width: undefined,
            height: undefined,
            shouldShowVideo: false,
            player: null,
            shouldAutoplayOnReady: false,
        };
    },
    watch: {
        isActive(newValue) {
            if (newValue) {
                if (!this.shouldShowVideo) {
                    this.shouldAutoplayOnReady = true;
                    this.loadVideo();
                } else if (this.player) {
                    this.player.play().catch((error) => {
                        console.warn('Video play failed:', error);
                    });
                }
            } else if (this.player) {
                this.player.pause();
            }
        },
    },
    mounted() {
        if (this.$refs.video !== undefined) {
            this.width = this.$refs.video.clientWidth;
            this.height = this.$refs.video.clientHeight;
        }
        
        // If this video is active on mount, load it immediately
        if (this.isActive) {
            this.loadVideo();
        }
    },
    methods: {
        loadVideo() {
            this.shouldShowVideo = true;
        },
        onVideoReady(player) {
            this.player = player;
            this.$emit('video-ready', player);
            
            if (this.isActive || this.shouldAutoplayOnReady) {
                this.shouldAutoplayOnReady = false;
                player.play().catch((error) => {
                    console.warn('Video autoplay failed:', error);
                });
            } else {
                player.pause();
            }
        },
        onVideoPlay() {
            // Video started playing
        },
        onVideoPause() {
            // Video was paused
        },
        pause() {
            if (this.player) {
                this.player.pause();
            }
        },
        play() {
            if (this.player) {
                this.player.play();
            }
        },
    },
};
</script>

<style scoped lang="scss">
</style>
